import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { collectioncreate, collectionupdate, individualcollectiondatewise, individualmemberlist, listbanks } from "../../../services/admin";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";

export default function AddIndividualCollection() {
    const navigate = useNavigate();
    const { id, mid } = useParams();
    const [mlist, setMlist] = useState([]);
    const [mmlist, setMMlist] = useState([]);
    const [memberid, setMemberId] = useState("");
    const [mmemberid, setMMemberId] = useState("");
    const [cdate, setCDate] = useState("");
    const [clist, setCList] = useState([]);
    const [isalready, setIsAlready] = useState(false);
    const location = useLocation();
    const [urllink, setUrllink] = useState("");
    const [banklist, setBankList] = useState([]);

    const paymentMethods = [
        { value: 'cash', label: 'Cash' },
        { value: 'gpay', label: 'GPay' },
        { value: 'phonepe', label: 'PhonePe' },
        { value: 'paytm', label: 'Paytm' },
        { value: 'bank_transfer', label: 'Bank Transfer' },
        { value: 'cheque', label: 'Cheque' },
        { value: 'upi', label: 'UPI' }
    ];

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        // Load bank list first
        listbanks().then((bankRes) => {
            let bankArr = [];
            if (bankRes.status === true && bankRes.data.length > 0) {
                for (let i = 0; i < bankRes.data.length; i++) {
                    bankArr.push({
                        value: bankRes.data[i].id,
                        label: bankRes.data[i].bank_name
                    })
                }
                setBankList(bankArr);
            }

            // After banks are loaded, handle edit or add mode
            if (path === "editindividualcollection") {
                setCDate(id);
                setMemberId(mid);

                // Load member list for edit mode
                const temp = new FormData();
                temp.append("branch", localStorage.getItem("branch"));
                temp.append("date", moment(new Date()).format("YYYY-MM-DD"));
                individualmemberlist(temp).then((res) => {
                    if (res.status === true) {
                        setMMlist(res.data);
                        let arr = [];
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                arr.push({
                                    value: res.data[i].id,
                                    label: res.data[i].member_name
                                })
                            }
                            setMlist(arr);

                            // Set selected member
                            const selectedMember = arr.find(m => m.value == mid);
                            if (selectedMember) {
                                setMMemberId(selectedMember);
                            }
                        }
                    }
                });

                // Load collection data for the member and date
                if (mid && id) {
                    const editTemp = new FormData();
                    editTemp.append("member_id", mid);
                    editTemp.append("collection_date", id);
                    individualcollectiondatewise(editTemp).then((res) => {
                        if (res.status === true) {
                            // Map the loan entries with existing collection data
                            const mappedData = res.data.details.map(entry => {
                                // Add payment method and bank objects for Select components
                                let paymentMethodObj = null;
                                if (entry.payment_method) {
                                    paymentMethodObj = paymentMethods.find(pm => pm.value === entry.payment_method);
                                }

                                let bankIdObj = null;
                                if (entry.bank_id && bankArr.length > 0) {
                                    bankIdObj = bankArr.find(b => b.value == entry.bank_id);
                                }

                                return {
                                    ...entry,
                                    loan_collection: entry.loanpaid || 0,
                                    payment_method_obj: paymentMethodObj,
                                    bank_id_obj: bankIdObj
                                };
                            });
                            setCList(mappedData);
                        }
                    });
                }
            } else {
                setCDate(moment(new Date()).format("YYYY-MM-DD"));
                const temp = new FormData();
                temp.append("branch", localStorage.getItem("branch"));
                temp.append("date", moment(new Date()).format("YYYY-MM-DD"));
                individualmemberlist(temp).then((res) => {
                    if (res.status === true) {
                        setMMlist(res.data);
                        let arr = [];
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                arr.push({
                                    value: res.data[i].id,
                                    label: res.data[i].member_name
                                })
                            }
                            setMlist(arr);
                        }
                    }
                })
            }
        });
    }, [location.pathname])

    function loadlist(ldate){
        setCDate(ldate);
        setCList([]);
        setMlist([]);
        setMMlist([]);
        setMemberId("");
        setMMemberId("");
        const temp = new FormData();
                temp.append("branch", localStorage.getItem("branch"));
                temp.append("date", ldate);
                individualmemberlist(temp).then((res) => {
                    if (res.status === true) {
                        setMMlist(res.data);
                        let arr = [];
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                arr.push({
                                    value: res.data[i].id,
                                    label: res.data[i].member_name
                                })
                            }
                            setMlist(arr);
                        }
                    }
                })
    }

    function handlemember(e) {
        if (e !== null) {
            setMMemberId(e)
            setMemberId(e.value);
            funlist(e.value, cdate);
        } else {
            setMMemberId("")
            setMemberId("");
            funlist("", cdate);
        }
    }

    function funlist(fid, fdate) {
        setCDate(fdate);
        setCList([]);

        if (fid != "" && fdate != "") {
            const temp = new FormData();
            temp.append("member_id", fid);
            temp.append("collection_date", fdate);
            individualcollectiondatewise(temp).then((res) => {
                if (res.status === true) {
                    // Check if collection already exists (only for add mode)
                    if (res.data.already_received && urllink !== "editindividualcollection") {
                        setIsAlready(true);
                    } else {
                        setIsAlready(false);
                    }

                    // For a new posting the Collection Amount defaults to the full
                    // Total Due (EMI total + overdue); an already-received entry
                    // keeps whatever was actually paid.
                    const alreadyReceived = res.data.already_received && urllink !== "editindividualcollection";

                    // Map data and add payment method/bank objects for Select components
                    const mappedData = res.data.details.map(entry => {
                        let paymentMethodObj = null;
                        if (entry.payment_method) {
                            paymentMethodObj = paymentMethods.find(pm => pm.value === entry.payment_method);
                        }

                        let bankIdObj = null;
                        if (entry.bank_id && banklist.length > 0) {
                            bankIdObj = banklist.find(b => b.value == entry.bank_id);
                        }

                        const totalDue = (parseFloat(entry.loan_total) || 0) + (parseFloat(entry.loan_od) || 0);

                        return {
                            ...entry,
                            loan_collection: alreadyReceived ? (entry.loanpaid || 0) : totalDue,
                            payment_method_obj: paymentMethodObj,
                            bank_id_obj: bankIdObj
                        };
                    });

                    setCList(mappedData);
                }
            });
        }
    }

    const handleInputChange = (index, field, value) => {
        const updatedMembers = [...clist];
        updatedMembers[index][field] = value;
        setCList(updatedMembers);
    };

    const calculateTotal = (member) => {
        const loanTotal = parseFloat(member.loan_total) || 0;
        const loanOD = parseFloat(member.loan_od) || 0;
        return loanTotal + loanOD;
    };

    function handleSubmit(e) {
        e.preventDefault();
        let sdata = true;
        if (urllink !== "editindividualcollection") {
            sdata = clist.every((item) => item.loan_collection != null && item.loan_collection != "" && item.loan_collection >= 0);
        }

        let errorFound = false;
        clist.forEach((item, index) => {
            const loanTotal = parseFloat(item.loan_total) || 0;
            const loanOD = parseFloat(item.loan_od) || 0;
            const loanCollection = parseFloat(item.loan_collection) || 0;
            const totalDue = loanTotal + loanOD;

            if (loanCollection !== 0 && loanCollection > totalDue) {
                errorFound = true;
                toast.error(
                    `Collection amount must not exceed total due amount (${totalDue}).`
                );
            }

            // Validate payment method
            if (loanCollection > 0 && !item.payment_method) {
                errorFound = true;
                toast.error(`Please select payment method for Loan #${index + 1}`);
            }

            // Validate bank for non-cash payments
            if (loanCollection > 0 && item.payment_method && item.payment_method !== 'cash' && !item.bank_id) {
                errorFound = true;
                toast.error(`Please select bank for Loan #${index + 1} (${item.payment_method})`);
            }
        });

        if (!errorFound) {
            if (sdata) {
                setLoading(true);
                const temp = new FormData();
                for (let i = 0; i < clist.length; i++) {
                    temp.append(`loan_members[${i}][loan_id]`, clist[i].loanid);
                    temp.append(`loan_members[${i}][loan_member]`, memberid);
                    temp.append(`loan_members[${i}][loan_amount]`, clist[i].loanamount);
                    temp.append(`loan_members[${i}][loan_installment]`, clist[i].loanins);
                    temp.append(`loan_members[${i}][loan_principle]`, clist[i].loan_principle);
                    temp.append(`loan_members[${i}][loan_interest]`, clist[i].loan_interest);
                    temp.append(`loan_members[${i}][loan_total]`, clist[i].loan_total);
                    temp.append(`loan_members[${i}][loan_od]`, clist[i].loan_od || 0);
                    temp.append(`loan_members[${i}][total_collection]`, clist[i].loan_collection || "");
                    temp.append(`loan_members[${i}][payment_method]`, clist[i].payment_method || "");
                    temp.append(`loan_members[${i}][bank_id]`, clist[i].bank_id || "");
                    temp.append(`loan_members[${i}][remarks]`, clist[i].loan_remarks || "");
                    temp.append(`loan_members[${i}][collection_date]`, cdate);
                    temp.append(`loan_members[${i}][scheme_name]`, clist[i].scheme_name || "");
                }

                if (urllink === "editindividualcollection") {
                    collectionupdate(temp).then((res) => {
                        if (res.status === true) {
                            setLoading(false);
                            toast.success(res.message);
                            navigate("/collection/allindividualcollection");
                        } else {
                            setLoading(false);
                            toast.error(res.message);
                        }
                    });
                } else {
                    collectioncreate(temp).then((res) => {
                        if (res.status === true) {
                            setLoading(false);
                            toast.success(res.message);
                            navigate("/collection/allindividualcollection");
                        } else {
                            setLoading(false);
                            toast.error(res.message);
                        }
                    });
                }
            } else {
                toast.error("Please Enter Collection Amount");
            }
        }
    }

    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);

    return (
        <div>
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">
                        {urllink === "editindividualcollection" ? "Edit Individual Recovery Posting" : "Individual Recovery Posting"}
                    </h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Collection</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {urllink === "editindividualcollection" ? "Edit Individual Recovery Posting" : "Individual Recovery Posting"}
                        </li>
                    </ol>
                </div>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading &&
                <div className="content-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h2 className="main-content-title tx-24 mg-b-5">
                                        Select Member
                                    </h2>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-6 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Collection Date
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    value={cdate}
                                                    min={localStorage.getItem("Role") == 4 ? cdate : ''}
                                                    max={localStorage.getItem("Role") == 4 ? cdate : ''}
                                                    // onChange={(e) => funlist(memberid, e.target.value)}
                                                    onChange={(e) => loadlist(e.target.value)}

                                                    disabled={urllink === "editindividualcollection" ? true : false}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Member<span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Member"
                                                    value={mmemberid}
                                                    options={mlist}
                                                    onChange={handlemember}
                                                    isSearchable={true}
                                                    isClearable
                                                    isDisabled={urllink === "editindividualcollection" ? true : false}
                                                />
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Alert for already received collection on add page */}
                        {isalready && urllink !== "editindividualcollection" && (
                            <div className="col-lg-12 mt-2">
                                <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                    <strong>Notice:</strong> Collection has already been received for this member on this date. The data below is read-only.
                                </div>
                            </div>
                        )}

                        {clist.map((member, index) => (
                            <div className="col-lg-12 mt-2" key={index}>
                                <Card>
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <h5 className="mb-0">Loan #{index + 1}</h5>
                                        <span className="badge bg-primary">Installment: {member.loanins || 'N/A'}</span>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label fw-bold">Loan Date</label>
                                                <input
                                                    type="text"
                                                    value={member.loan_date || ""}
                                                    className="form-control"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label fw-bold">Due Date</label>
                                                <input
                                                    type="text"
                                                    value={member.loan_duedate || ""}
                                                    className="form-control"
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">Loan Amount</label>
                                                <input
                                                    type="text"
                                                    value={member.loanamount || ""}
                                                    className="form-control"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">Principle</label>
                                                <input
                                                    type="text"
                                                    value={member.loan_principle || ""}
                                                    className="form-control"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">Interest</label>
                                                <input
                                                    type="text"
                                                    value={member.loan_interest || ""}
                                                    className="form-control"
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">EMI Total</label>
                                                <input
                                                    type="text"
                                                    value={member.loan_total || ""}
                                                    className="form-control"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">Overdue (OD)</label>
                                                <input
                                                    type="text"
                                                    value={member.loan_od || 0}
                                                    className="form-control"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">Total Due</label>
                                                <input
                                                    type="text"
                                                    value={calculateTotal(member)}
                                                    className="form-control bg-light"
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold text-success">Collection Amount <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    value={member.loan_collection || ""}
                                                    className="form-control border-success"
                                                    readOnly={isalready}
                                                    onInput={(e) => {
                                                        const value = e.target.value;
                                                        if (/[^0-9.]/.test(value)) {
                                                            e.target.value = value.replace(/[^0-9.]/g, '');
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const loanTotal = parseFloat(member.loan_total) || 0;
                                                        const loanOD = parseFloat(member.loan_od) || 0;
                                                        const totalDue = loanTotal + loanOD;

                                                        if (value !== "") {
                                                            if (parseFloat(value) > totalDue) {
                                                                toast.error("Collection amount must not exceed total due amount (" + totalDue + ")");
                                                                e.target.value = "";
                                                                handleInputChange(index, 'loan_collection', "");
                                                            } else {
                                                                handleInputChange(index, 'loan_collection', value);
                                                            }
                                                        } else {
                                                            handleInputChange(index, 'loan_collection', "");
                                                        }
                                                    }}
                                                    placeholder="Enter collection amount"
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">Payment Method <span className="text-danger">*</span></label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Payment Method"
                                                    value={member.payment_method_obj || null}
                                                    options={paymentMethods}
                                                    onChange={(e) => {
                                                        handleInputChange(index, 'payment_method', e ? e.value : "");
                                                        handleInputChange(index, 'payment_method_obj', e);
                                                        // Clear bank if cash is selected
                                                        if (e && e.value === 'cash') {
                                                            handleInputChange(index, 'bank_id', "");
                                                            handleInputChange(index, 'bank_id_obj', null);
                                                        }
                                                    }}
                                                    isSearchable={true}
                                                    isClearable
                                                    isDisabled={isalready}
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="form-label fw-bold">Bank {member.payment_method && member.payment_method !== 'cash' && <span className="text-danger">*</span>}</label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Bank"
                                                    value={member.bank_id_obj || null}
                                                    options={banklist}
                                                    onChange={(e) => {
                                                        handleInputChange(index, 'bank_id', e ? e.value : "");
                                                        handleInputChange(index, 'bank_id_obj', e);
                                                    }}
                                                    isSearchable={true}
                                                    isClearable
                                                    isDisabled={isalready || !member.payment_method || member.payment_method === 'cash'}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-2">
                                                <label className="form-label fw-bold">Remarks</label>
                                                <input
                                                    type="text"
                                                    readOnly={isalready}
                                                    value={member.loan_remarks || ""}
                                                    className="form-control"
                                                    onChange={(e) => handleInputChange(index, 'loan_remarks', e.target.value)}
                                                    placeholder="Enter remarks"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        ))}

                        {/* Summary Card */}
                        {clist.length > 0 && (
                            <div className="col-lg-12 mt-2">
                                <Card>
                                    <div className="card-header text-white">
                                        <h5 className="mb-0">Summary</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-3 mb-3">
                                                <div className="p-3 bg-light rounded">
                                                    <small className="text-muted d-block">Total Loan Amount</small>
                                                    <h5 className="mb-0">₹{clist.reduce((total, member) => total + parseFloat(member.loanamount || 0), 0).toFixed(2)}</h5>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="p-3 bg-light rounded">
                                                    <small className="text-muted d-block">Total Principle</small>
                                                    <h5 className="mb-0">₹{clist.reduce((total, member) => total + parseFloat(member.loan_principle || 0), 0).toFixed(2)}</h5>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="p-3 bg-light rounded">
                                                    <small className="text-muted d-block">Total Interest</small>
                                                    <h5 className="mb-0">₹{clist.reduce((total, member) => total + parseFloat(member.loan_interest || 0), 0).toFixed(2)}</h5>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="p-3 bg-light rounded">
                                                    <small className="text-muted d-block">Total EMI</small>
                                                    <h5 className="mb-0">₹{clist.reduce((total, member) => total + parseFloat(member.loan_total || 0), 0).toFixed(2)}</h5>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-3 mb-3">
                                                <div className="p-3 bg-warning bg-opacity-10 rounded">
                                                    <small className="text-white d-block">Total Overdue</small>
                                                    <h5 className="mb-0 text-warning">₹{clist.reduce((total, member) => total + parseFloat(member.loan_od || 0), 0).toFixed(2)}</h5>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="p-3 bg-danger bg-opacity-10 rounded">
                                                    <small className="text-white d-block">Total Due</small>
                                                    <h5 className="mb-0 text-danger">₹{clist.reduce((total, member) => {
                                                        const loanTotal = parseFloat(member.loan_total || 0);
                                                        const loanOD = parseFloat(member.loan_od || 0);
                                                        return total + loanTotal + loanOD;
                                                    }, 0).toFixed(2)}</h5>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div className="p-3 bg-success bg-opacity-10 rounded">
                                                    <small className="text-white d-block">Total Collection</small>
                                                    <h5 className="mb-0 text-success">₹{clist.reduce((total, member) => total + parseFloat(member.loan_collection || 0), 0).toFixed(2)}</h5>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        )}

                        {/* Action Buttons */}
                        {clist.length > 0 && (
                            <div className="col-lg-12 mt-3">
                                <div className="text-end">
                                    {urllink === "editindividualcollection" &&
                                        <button onClick={() => navigate("/collection/allindividualcollection")} className="btn btn-secondary me-2">
                                            <i className="fa fa-arrow-left me-2"></i>Back
                                        </button>
                                    }
                                    {!isalready &&
                                        <button className="btn btn-success" onClick={handleSubmit}>
                                            <i className="fa fa-check me-2"></i>Submit Collection
                                        </button>
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            }
        </div>
    );
}
